import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "px-2 border-r-2 border-grey" }
const _hoisted_3 = { class: "flex flex-col text-left" }
const _hoisted_4 = { class: "flex flex-col flex-grow" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Games for selected group or user", -1 /* HOISTED */)
const _hoisted_6 = { class: "m-2" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flex flex-col flex-grow py-4 text-left m-2 overflow-y-auto" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold" }, "Game Details", -1 /* HOISTED */)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Remove ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectionBox = _resolveComponent("SelectionBox")!
  const _component_SlButton = _resolveComponent("SlButton")!
  const _component_MonitorGameItem = _resolveComponent("MonitorGameItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode("SlButton class=\"mb-8 focus:outline-none bg-blue-button text-white justify-self-end\" id=\"button-add\" @click=\"addGame()\"> Add </SlButton"),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SelectionBox, {
          id: "select-locationfilter",
          modelValue: _ctx.selectedGroup,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedGroup) = $event)),
          label: 'Filter by owners in a group',
          options: _ctx.groupOptionList,
          class: "m-2",
          onChange: _ctx.filterGames
        }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"]),
        _createVNode(_component_SelectionBox, {
          id: "select-userfilter",
          modelValue: _ctx.selectedUser,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedUser) = $event)),
          label: 'Filter by a single owner',
          options: _ctx.userOptionList,
          class: "m-2",
          onChange: _ctx.filterGames
        }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (g, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: 'ap-' + i,
                class: "cursor-pointer",
                onClick: ($event: any) => (_ctx.selectGame(g))
              }, [
                (_ctx.selectedGame && g._id === _ctx.selectedGame._id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "✔︎ "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9)),
                _createTextVNode(" " + _toDisplayString(g.name), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_7))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      (_ctx.selectedGame && _ctx.selectedGame._id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_MonitorGameItem, {
              game: _ctx.selectedGame,
              edit: true,
              selected: true,
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SlButton, {
                  class: "my-2 mr-2",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeParticipant()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["game"])
          ]))
        : _createCommentVNode("v-if", true),
      _hoisted_14
    ])
  ]))
}